<div class="bg-m0 relative flex h-full w-full flex-col rounded shadow">
  <div class="mb-6 mt-6 flex h-11 flex-shrink-0 flex-row items-center">
    <div class="ml-10 flex-shrink-0">
      <button
        type="button"
        class="border-s400 text-s500 hover:bg-s100 flex select-none flex-row items-center rounded border p-4 py-2 focus:outline-none"
        (click)="newSession()"
      >
        <div>New Session</div>
      </button>
    </div>

    <button
      tp="Refresh sessions"
      type="button"
      class="hover:bg-m200 ml-5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
      (click)="loadSessions()"
    >
      <m-refresh-icon></m-refresh-icon>
    </button>

    <div class="relative ml-5 flex h-7 w-7 flex-shrink-0">
      <ngx-spinner
        *ngIf="isRefreshing"
        [name]="spinnerName"
        color="#0084d1"
        bdColor="#00000000"
        size="default"
        type="ball-clip-rotate"
        [fullScreen]="false"
        [disableAnimation]="true"
        [zIndex]="10"
      >
      </ngx-spinner>
    </div>

    <div class="flex flex-1"></div>
  </div>

  <div class="divide-s300 ml-6 mr-6 flex flex-col divide-y">
    <div class="flex flex-row"></div>
    <div class="flex flex-row"></div>
  </div>

  <div
    *ngIf="sessionsLoaded && sessions.length === 0 && !hasMoreArchived"
    class="pointer-events-none absolute inset-0 flex select-none items-center justify-center text-xl"
  >
    Sessions are empty
  </div>

  <div
    *ngIf="sessionsLoaded && sessions.length === 0 && hasMoreArchived"
    class="flex h-2 w-full flex-grow flex-col overflow-y-auto"
  >
    <!-- Load archived sessions button -->
    <div class="ml-6 mr-9 mt-4 flex justify-center pr-3">
      <button
        type="button"
        class="text-s400 hover:text-s500 py-2 text-base focus:outline-none"
        [disabled]="isLoadingArchived"
        (click)="loadArchivedSessions()"
      >
        {{ isLoadingArchived ? 'Loading...' : 'Load archived sessions' }}
      </button>
    </div>
  </div>

  <div
    *ngIf="sessions.length > 0"
    class="flex h-2 w-full flex-grow flex-col overflow-y-auto"
  >
    <ng-scrollbar
      [orientation]="'vertical'"
      [visibility]="'hover'"
      [appearance]="'compact'"
    >
      <div class="mt-2 h-full w-full pb-6">
        <div
          *ngFor="let session of sessions; trackBy: trackBySessionId"
          class="hover:bg-m50 group ml-6 mr-6 flex h-11 cursor-pointer select-none flex-row items-center rounded pl-5 pr-2"
          (click)="openSession(session)"
        >
          <div
            class="mr-4 flex w-6 flex-shrink-0 items-center justify-center"
            [ngClass]="{
              'text-m600': session.sessionId === currentSession?.sessionId,
              'text-s400':
                session.status === 'Archived' &&
                session.sessionId !== currentSession?.sessionId,
              'text-s1':
                session.sessionId !== currentSession?.sessionId &&
                session.status !== 'Archived'
            }"
          >
            <span
              *ngIf="session.type === sessionTypeEnum.Explorer"
              class="flex [&_svg]:h-[22px] [&_svg]:w-[22px]"
              ><m-explorer-icon></m-explorer-icon
            ></span>
            <m-editor-icon
              *ngIf="session.type === sessionTypeEnum.Editor"
            ></m-editor-icon>
          </div>
          <span
            class="min-w-0 flex-1 truncate text-[17px]"
            [ngClass]="{
              'text-m600': session.sessionId === currentSession?.sessionId,
              'font-semibold':
                session.sessionId === currentSession?.sessionId ||
                session.sessionId === selectedRepoId,
              'text-s400':
                session.status === 'Archived' &&
                session.sessionId !== currentSession?.sessionId,
              'text-s1':
                session.sessionId !== currentSession?.sessionId &&
                session.status !== 'Archived'
            }"
            >{{ session.displayTitle }}</span
          >

          <span
            *ngIf="session.status !== 'Active'"
            class="ml-4 w-[84px] flex-shrink-0 text-right text-[16px]"
            [ngClass]="{
              'text-s400': session.status === 'Archived',
              'text-s1': session.status !== 'Archived'
            }"
            >{{ session.status }}</span
          >

          <div
            class="ml-3 flex h-9 w-9 flex-shrink-0 items-center justify-center"
          >
            <button
              *ngIf="session.status !== 'Archived'"
              class="hover:bg-m200 invisible flex h-8 w-8 items-center justify-center rounded focus:outline-none group-hover:visible"
              [ngClass]="{
                'text-s400 cursor-default': session.status === 'New'
              }"
              [disabled]="session.status === 'New'"
              (click)="archiveSession($event, session)"
            >
              <span class="flex [&_svg]:h-[20px] [&_svg]:w-[20px]"
                ><m-archive-icon></m-archive-icon
              ></span>
            </button>
          </div>

          <div
            class="ml-3 flex h-9 w-9 flex-shrink-0 items-center justify-center"
          >
            <button
              class="hover:bg-m200 invisible flex h-8 w-8 items-center justify-center rounded focus:outline-none group-hover:visible"
              [tp]="templateSessionMenu"
              [tpHideOnEscape]="true"
              tpVariation="menu"
              className="my-menu"
              #tpRef="tippy"
              (click)="$event.stopPropagation()"
            >
              <m-dots-vertical-icon></m-dots-vertical-icon>
            </button>

            <ng-template #templateSessionMenu>
              <div class="border-s4 bg-m0 w-48 rounded-md border-2 shadow-xl">
                <button
                  *ngIf="session.status === 'Active'"
                  class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
                  [ngClass]="{
                    'text-s400 cursor-default':
                      session.type === sessionTypeEnum.Explorer
                  }"
                  [disabled]="session.type === sessionTypeEnum.Explorer"
                  [tp]="
                    session.type === sessionTypeEnum.Explorer
                      ? 'Pause is not needed for Explorer session'
                      : null
                  "
                  (click)="tpRef.hide(); pauseSession($event, session)"
                  >Pause Session</button
                >
                <button
                  class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
                  [ngClass]="{
                    'text-s400 cursor-default': session.status === 'New'
                  }"
                  [disabled]="session.status === 'New'"
                  (click)="tpRef.hide(); renameSession($event, session)"
                  >Rename Session</button
                >
                <button
                  *ngIf="session.status !== 'Archived'"
                  class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
                  [ngClass]="{
                    'text-s400 cursor-default': session.status === 'New'
                  }"
                  [disabled]="session.status === 'New'"
                  (click)="tpRef.hide(); archiveSession($event, session)"
                  >Archive Session</button
                >
                <button
                  class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
                  [ngClass]="{
                    'text-s400 cursor-default': session.status === 'New'
                  }"
                  [disabled]="session.status === 'New'"
                  (click)="tpRef.hide(); deleteSession($event, session)"
                  >Delete Session</button
                >
              </div>
            </ng-template>
          </div>
        </div>

        <!-- Load archived sessions button -->
        <div class="ml-6 mr-9 mt-4 flex justify-center pr-3">
          <button
            type="button"
            class="text-s400 hover:text-s500 py-2 text-base focus:outline-none"
            [disabled]="isLoadingArchived"
            (click)="loadArchivedSessions()"
          >
            {{
              isLoadingArchived
                ? 'Loading...'
                : archivedLastCreatedTs ||
                    currentSession?.status === sessionStatusArchived
                  ? 'Load more archived sessions'
                  : 'Load archived sessions'
            }}
          </button>
        </div>
      </div>
    </ng-scrollbar>
  </div>
</div>
<div *ngIf="sessions$ | async"></div>
<div *ngIf="hasMoreArchived$ | async"></div>
<div *ngIf="session$ | async"></div>
<div *ngIf="nav$ | async"></div>
